"use strict";
/**
 * Where this deploy fetches its own GraphQL.
 *
 * Netlify's URL is the site's primary address, which for a deploy preview is
 * production. So a deploy preview of this app fetches
 * prc.integralads.com/api/graphql and renders production's answers: production's
 * index name, production's sort options, production's settings. Nothing
 * resolved on the server can be previewed. Deploy preview 609 built
 * resources_preview, resolved it correctly at build and wrote it to
 * /search-config.json, and the page still asked for
 * resources_by_updatedAt_desc, because production answered the page. The Help
 * Center half of the same pull request looked right only because its whole
 * change travels as client-side query parameters.
 *
 * DEPLOY_PRIME_URL is the address of the deploy doing the asking and is the
 * obvious fix, but it does not work yet: /api/graphql returns 500 on a deploy
 * preview of either site, while the same route on production and on the develop
 * branch deploy returns 200. Same build, same code, same set of environment
 * keys. Until that is understood, pointing a preview at itself trades a preview
 * that renders the wrong configuration for one that renders nothing.
 *
 * So this stays as it was, deliberately, and the limit is written down rather
 * than rediscovered: preview a server-side change by reading
 * /search-config.json and by measuring the indices directly, not by trusting
 * the page.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphqlEndpoint = void 0;
// DEPLOY_URL supplied by netlify, VERCEL_URL supplied by vercel
var deployUrl = process.env.URL || (process.env.VERCEL_URL ? "https://".concat(process.env.VERCEL_URL) : null);
exports.graphqlEndpoint = process.env.CI || process.env.NEXT_PHASE === 'phase-production-build' || process.env.STAGE === 'build' || !deployUrl
    ? 'http://localhost:5000/graphql'
    : "".concat(deployUrl, "/api/graphql");
exports.default = exports.graphqlEndpoint;
